import styled from 'styled-components';

export const ActionsRoot = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`;
